import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "base-title-button" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1)
const _hoisted_3 = { class: "d-flex align-items-start" }
const _hoisted_4 = {
  class: "nav flex-column nav-pills me-3",
  id: "v-pills-tab",
  role: "tablist",
  "aria-orientation": "vertical"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "tab-content flex-grow-1",
  id: "v-pills-tabContent"
}
const _hoisted_7 = { class: "table table-hover table-v2" }
const _hoisted_8 = { colspan: "2" }
const _hoisted_9 = { class: "buttons d-flex justify-content-end align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1)
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('deliveryCosts'),
        "help-text": _ctx.$t('descriptionDeliveryCosts'),
        mb: 4,
        "show-refresh-button": "",
        onRefresh: this.reloadContent
      }, {
        buttons: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_link, {
              to: {name: 'delivery-cost-rule-new'},
              class: "btn btn-hover icon-link"
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["title", "help-text", "onRefresh"]),
      _createVNode(_component_AlertError2, {
        error: this.pageUI.getError()
      }, null, 8, ["error"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.deliveryMethods, (deliveryMethod) => {
            return (_openBlock(), _createElementBlock("button", {
              key: deliveryMethod,
              type: "button",
              onClick: ($event: any) => (this.showTab(deliveryMethod.code)),
              class: _normalizeClass(["nav-link text-start", {
            'active': _ctx.activeTab === deliveryMethod.code,
          }])
            }, _toDisplayString(deliveryMethod.description), 11, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.deliveryMethods, (deliveryMethod) => {
            return (_openBlock(), _createElementBlock("div", {
              key: deliveryMethod,
              class: _normalizeClass(["tab-pane fade", {
            'show': _ctx.activeTab === deliveryMethod.code,
            'active': _ctx.activeTab === deliveryMethod.code,
          }])
            }, [
              _createElementVNode("table", _hoisted_7, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('country')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('postalCode')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('fromOrEq')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('to')), 1),
                    _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('priceInclVat')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.deliveryCostRulesForDeliveryMethod, (rule) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "align-middle",
                      key: rule
                    }, [
                      _createElementVNode("td", null, _toDisplayString(rule.country?.description), 1),
                      _createElementVNode("td", null, _toDisplayString(rule.postal_code), 1),
                      _createElementVNode("td", null, _toDisplayString(rule.order_amount_with_vat_from), 1),
                      _createElementVNode("td", null, _toDisplayString(rule.order_amount_with_vat_to), 1),
                      _createElementVNode("td", null, _toDisplayString(rule.delivery_price_with_vat), 1),
                      _createElementVNode("td", _hoisted_9, [
                        _createVNode(_component_router_link, {
                          class: "btn btn-icon btn-primary ms-2",
                          to: this.goToDetail(rule.id)
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (this.deleteDeliveryCostRule(rule.id)),
                          class: "btn btn-icon btn-danger ms-2"
                        }, _hoisted_13, 8, _hoisted_11)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}